import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

import { SWRConfiguration } from 'swr'

import useUser from 'hooks/useUser'

import { useUks } from 'lib/api/uks'

export function useUKSServicePlan(config?: SWRConfiguration) {
  const { user } = useUser()
  const swr = useUks(user?.id ? ['serviceMethodsGet', user.id] : null, {
    ...config,
    revalidateOnFocus: false
  })

  const servicePlan = swr?.data?.result

  useEffect(() => {
    if (user && servicePlan) {
      const { created, email, firstname, id, lastname, onboarded, status, verified } = user
      const tier = servicePlan.tier

      Sentry.setUser({
        created,
        email,
        firstname,
        id,
        lastname,
        name: email,
        onboarded,
        status,
        tier,
        verified
      })
      ;(window as any).rum?.setUser({
        created,
        email,
        firstname,
        id,
        lastname,
        name: email,
        onboarded,
        status,
        tier,
        verified
      })
    }
  }, [user, servicePlan])

  return {
    loading: !swr.data && !swr.error,
    servicePlan,
    ...swr
  }
}
